import { AutocompleteWithLabel, InputWithLabel } from '@adotel/components'
import { useLazyQuery } from '@apollo/client'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useMemo } from 'react'

import { PROVIDERS_QUERY } from '../../graphql/providerQueries'
import { getTranslate } from '../../localization'
import { ProviderBrief } from '../../types/provider'
import useStyles from './styles/PoliciesFilters.styles'

interface PoliciesFiltersProps {
  inputValue: string | undefined
  loadingForDisableSearchBox: boolean
  hasAccessToChangeProvider: boolean | undefined
  setAutoCompleteProvider: React.Dispatch<any>
  autoCompleteProvider: any
  setSearchInputValue: React.Dispatch<React.SetStateAction<string>>
}

const PoliciesFilters: React.FC<PoliciesFiltersProps> = ({
  inputValue,
  loadingForDisableSearchBox,
  hasAccessToChangeProvider,
  setAutoCompleteProvider,
  autoCompleteProvider,
  setSearchInputValue
}) => {
  const classes = useStyles()
  const [getProviders, { data, loading }] = useLazyQuery<{
    providers: ProviderBrief[]
  }>(PROVIDERS_QUERY)

  useEffect(() => {
    if (hasAccessToChangeProvider) {
      getProviders()
    }
  }, [])

  const options = useMemo(
    () =>
      data
        ? data?.providers.map((pr) => ({
            label: pr.name,
            value: pr.providerCode
          }))
        : [],
    [data]
  )

  return (
    <div
      className={[
        classes.root,
        !hasAccessToChangeProvider ? classes.rootForTenantRole : ''
      ].join(' ')}>
      {hasAccessToChangeProvider && (
        <AutocompleteWithLabel
          value={autoCompleteProvider}
          getOptionLabel={(option) => option.label || ''}
          placeholder={getTranslate('please select a provider')}
          inputSize="small"
          noHelperText
          fullWidth
          options={options}
          onChange={(_, value: any) => {
            setAutoCompleteProvider(value)
            setSearchInputValue('')
          }}
          loading={loading}
          loadingText={getTranslate('Loading') + '...'}
        />
      )}

      <InputWithLabel
        placeholder={getTranslate('Search by policy titles')}
        autoComplete="off"
        noHelperText
        fullWidth
        inputSize="small"
        startIcon={<SearchIcon />}
        className={classes.searchInput}
        value={inputValue}
        onChange={(event) => setSearchInputValue(event.currentTarget.value)}
        disabled={loadingForDisableSearchBox}
      />
    </div>
  )
}

export default PoliciesFilters
